import { Column } from '@melements/front-components';
import styled from 'theme';

export const ServiceFormLabel = styled.label`
  font-size: ${p => p.theme.variables.fonts.size.bigger2};
  font-weight: ${p => p.theme.variables.fonts.weight.bold};
  line-height: 2;
  color: ${p => p.theme.variables.customColors.leadingColor.base};
  padding-bottom: 0.5rem;
  margin-top: 1rem;
`;

export const ServiceFormColumn = styled(Column)`
  padding-top: 1rem;
`;
